/**
 * A collection of constants for HTTP requests such as headers, and
 * content types.
 *
 * This is done in preference to pulling in third party libraries where
 * we only use a subset of the constants.
 */ export var Method;
(function(Method) {
    Method["Connect"] = "CONNECT";
    Method["Delete"] = "DELETE";
    Method["Get"] = "GET";
    Method["Head"] = "HEAD";
    Method["Options"] = "OPTIONS";
    Method["Patch"] = "PATCH";
    Method["Post"] = "POST";
    Method["Put"] = "PUT";
    Method["Trace"] = "TRACE";
})(Method || (Method = {}));
export var Header;
(function(Header) {
    Header["ContentLength"] = "Content-Length";
    Header["ContentType"] = "Content-Type";
    Header["XApiKey"] = "x-api-key";
})(Header || (Header = {}));
export var Mimetype;
(function(Mimetype) {
    Mimetype["Json"] = "application/json";
    Mimetype["PDF"] = "application/pdf";
    Mimetype["Jpeg"] = "image/jpeg";
    Mimetype["Png"] = "image/png";
    Mimetype["Ico"] = "image/x-icon";
    Mimetype["Mp4"] = "video/mp4";
})(Mimetype || (Mimetype = {}));
